import axios from "axios";

axios.defaults.withCredentials =
  window.WITHCREDENTIAL !== "undefined" ? window.WITHCREDENTIAL : true;
export const instance = axios.create({
  baseURL: `${window.SERVER_URL}/api`,
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let refreshSubscribers = [];

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;
    if (error.response && error.response.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const newAccessToken = await axios.get(
            `${window.SERVER_URL}/api/auth/refreshToken`
          );
          localStorage.setItem("accessToken", newAccessToken.data.data);
          isRefreshing = false;
          refreshSubscribers.forEach((callback) => callback());
          refreshSubscribers = [];
          return instance(originalConfig);
        } catch (e) {
          if (!e.response.data.status) {
            localStorage.clear();
            window.location.replace("/login");
          }
          // Logout user, remove tokens and redirect to login page
        }
      } else {
        return new Promise((resolve) => {
          refreshSubscribers.push((accessToken) => {
            originalConfig.headers.Authorization = `Bearer ${accessToken}`;
            resolve(instance(originalConfig));
          });
        });
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
